"use strict";

var Language = /* @__PURE__ */(Language2 => {
  Language2["En"] = "en";
  Language2["Ar"] = "ar";
  Language2["De"] = "de";
  Language2["El"] = "el";
  Language2["Es"] = "es";
  Language2["Fr"] = "fr";
  Language2["It"] = "it";
  Language2["Ja"] = "ja";
  Language2["Pt"] = "pt";
  Language2["Zh"] = "zh";
  Language2["Tw"] = "zh-tw";
  return Language2;
})(Language || {});
var AddressUsageType = /* @__PURE__ */(AddressUsageType2 => {
  AddressUsageType2[AddressUsageType2["Billing"] = 0] = "Billing";
  AddressUsageType2[AddressUsageType2["Shipping"] = 1] = "Shipping";
  AddressUsageType2[AddressUsageType2["ReturnShipping"] = 2] = "ReturnShipping";
  return AddressUsageType2;
})(AddressUsageType || {});
export { AddressUsageType, Language };
//# sourceMappingURL=constants.mjs.map
